'use client';

import { Icon } from '~/atoms';
import { Button } from '~/molecules';

type P = {
  readonly className?: string;
  readonly index: number;
  readonly isDisabled?: boolean;
  readonly length: number;
  readonly move: (from: number, to: number) => void;
};

export const ListSortButtons = ({
  className = '',
  index,
  isDisabled = false,
  length,
  move,
}: P) => {
  const moveUp = () => {
    move(index, index - 1);
  };

  const moveDown = () => {
    move(index, index + 1);
  };

  const isFirstChild = index === 0;
  const isLastChild = index === length - 1;

  return (
    <div className={className}>
      <Button
        buttonStyle="secondary"
        className="px-2"
        disabled={isDisabled || isFirstChild}
        icon={<Icon metaphor="arrowUp" />}
        size="small"
        title="Verschiebe dieses Element um eine Position nach oben"
        onClick={moveUp}
      />
      <Button
        buttonStyle="secondary"
        className="px-2"
        disabled={isDisabled || isLastChild}
        icon={<Icon metaphor="arrowDown" />}
        size="small"
        title="Verschiebe dieses Element um eine Position nach unten"
        onClick={moveDown}
      />
    </div>
  );
};
